export default "__VITE_ASSET__DeZozN_1__"